import React from 'react'
import './faq.css'
import faqBack from '../../images/art-1.svg'

// Accordion MUI component
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import faqImage from "../../images/shangu_updated/FAQ_s.jpg";

const Faq = () => {
    const [expanded, setExpanded] = React.useState(false)

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }
    return (
        <div
            className='faqs'
            id='faqs-section'
            // style={{ marginBottom: expanded ? '28rem' : '' }}
        >
            <div className='faqs-heading'>
                <div>
                    <h2>
                        Frequently Asked<span> Questions</span>
                    </h2>
                </div>
            </div>

            <div className='faq-item'>
                <div className='faq-1'></div>
                <div className='wrapper-faq'>
                    <div>
                        <img src={faqImage} alt='' className='faq__image' />
                    </div>
                    <div className='faq-inside'>
                        <div className='faqsAccordion'>
                            <Accordion
                                className='accordionBox accordionUpperCut'
                                expanded={expanded === 'panel1'}
                                onChange={handleChange('panel1')}
                            >
                                <AccordionSummary
                                    aria-controls='panel1bh-content'
                                    id='panel1bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        What is Legends of Shangu?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Legends of Shangu are a collection of
                                        digital characters that are randomly
                                        generated using artificial intelligence.
                                        This collection was created by David
                                        Huynh and inspired from the tale of the
                                        12 animals of the zodiac that protected
                                        the valley of Shangu on Chinese New
                                        Year!
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel8'}
                                onChange={handleChange('panel8')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        Who is the artist behind?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        The artist behind Legends of Shangu
                                        artwork is world renowned cartoon artist
                                        David Huynh. Most well known for his
                                        unique comical recreations on real
                                        dollar bills.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel10'}
                                onChange={handleChange('panel10')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        Why should I mint a NFT from Legends of
                                        Shangu?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Owning a Legend is more than just owning
                                        an NFT. It's about owning a slice of
                                        culture with unparalleled futuristic
                                        utility, a roadmap that continually
                                        rewards its holders and a marketing plan
                                        created by some of the best experts and
                                        marketers in the digital space.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel9'}
                                onChange={handleChange('panel9')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        How do I buy a Legends of Shangu NFT?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Click to the “How to Mint” tab to find
                                        out how to mint a Legend.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel5'}
                                onChange={handleChange('panel5')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        When is the launch?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Awakening: 8:30pm-11:30pm EST, 2nd
                                        February <br />
                                        White List 1: 6:30pm-9:30pm EST, 4th
                                        February
                                        <br />
                                        White List 2: 8:30pm-12:30pm EST, 6th
                                        February
                                        <br />
                                        Main Launch: 8:30pm EST, 7th February
                                        <br />
                                        The presale duration is to give everyone
                                        the chance to mint during a low gas fee
                                        period.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel3'}
                                onChange={handleChange('panel3')}
                            >
                                <AccordionSummary
                                    aria-controls='panel3bh-content'
                                    id='panel3bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        What is the mint price?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <p class='MuiTypography-root MuiTypography-body1 css-9l3uo3'>
                                            Awakening: 0.08 ETH <br />
                                            Whitelist 1: 0.1 ETH
                                            <br />
                                            Whitelist 2: 0.12 ETH
                                            <br /> Main Launch: TBD
                                            <br />
                                        </p>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel4'}
                                onChange={handleChange('panel4')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        How many can I mint?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        A maximum of 12 Legends can be minted
                                        per transaction. You can make 1
                                        transaction per sale. The acceptation
                                        being for Awakening sale members who can
                                        Mint up to 24 Legends at Awakening sale
                                        in 1 transaction.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel2'}
                                onChange={handleChange('panel2')}
                            >
                                <AccordionSummary
                                    aria-controls='panel2bh-content'
                                    id='panel2bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        How much is the max NFT mints at each
                                        phase from the total supply?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Awakening- 3000 total mints
                                        <br />
                                        Whitelist 1 - 2000 total mints <br />
                                        Whitelist 2- 1000 total mints <br />
                                        Main Sale- 1777 remaining or till supply cap
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel7'}
                                onChange={handleChange('panel7')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        When will the main giveaway be drawn?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        We will be announcing the winners of our
                                        main giveaway raffle on the 15th of
                                        February to celebrate the 2022 official
                                        Lantern Festival.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox'
                                expanded={expanded === 'panel6'}
                                onChange={handleChange('panel6')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        When is the reveal?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Our reveal party will be 48 hours after
                                        we have sold out.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox accordionBottomCut'
                                expanded={expanded === 'panel11'}
                                onChange={handleChange('panel11')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        What are gas fee’s?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Gas fees are an essential part of the
                                        Ethereum blockchain and are used to
                                        offset the costs the system uses to
                                        process each individual transaction.
                                        Don’t stress if you're new to NFT’s,
                                        this is totally normal.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox accordionBottomCut'
                                expanded={expanded === 'panel13'}
                                onChange={handleChange('panel13')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        Phase Limits
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Awakening: 3000 WL 1: 2000 WL 2: 1000
                                        Main sale: 1777 remaining or till supply
                                        cap
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox accordionBottomCut'
                                expanded={expanded === 'panel14'}
                                onChange={handleChange('panel14')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        What is the royalty reward system?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                    Buyers will own the full license for their unique NFT and a 10 percent Royalty will be set on the resale of our NFT’s that will go into a DAO Fund that will go back to our community for holding our NFT’s on the 1st of every month. We will give our holders 5 options every month of how we allocate those funds. This can be used to distribute back to investors in ETH as passive income or reinvested back in to the development of our project via the options we provide ie, marketing/franchising.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                className='accordionBox accordionBottomCut'
                                expanded={expanded === 'panel12'}
                                onChange={handleChange('panel12')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        Is there a team wallet?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Yes, there is a team wallet that will be
                                        used for marketing purposes. 377 total
                                        NFT’S will be reserved that means public
                                        will only have access to 7400 NFT’s.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion
                                className='accordionBox accordionBottomCut'
                                expanded={expanded === 'panel15'}
                                onChange={handleChange('panel15')}
                            >
                                <AccordionSummary
                                    aria-controls='panel4bh-content'
                                    id='panel4bh-header'
                                >
                                    <Typography
                                        sx={{ width: '100%', flexShrink: 0 }}
                                    >
                                        Is there a secondary collection launch? 
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        The Legends of Shangu eco-system is just
                                        getting started. We have 2 more drops
                                        planned that will all work in
                                        conjunction with this project and will
                                        continue to increase the value and
                                        rarity attached to every NFT to benefit
                                        its holders. For every 3 NFT’s you Mint
                                        from Collection 1, you will receive a
                                        free NFT from collection 2 that will be
                                        airdropped to you upon launch of that
                                        project.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faq
